import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { createProgrammesDumpReportApi } from "./api";
import {
    CreateProgrammesDumpReportRequest,
    ProgrammesDumpReportReduxTypes
} from "./types";

function* createProgrammesDumpReport({ payload }: CreateProgrammesDumpReportRequest): SagaIterator {
    try {
        const response = yield call(createProgrammesDumpReportApi, payload);
        yield put({
            type: ProgrammesDumpReportReduxTypes.PROGRAMMES_DUMP_REPORT_SUCCESS,
            payload: { data: response.data.data }
        });
    } catch (error: any) {
        yield put({
            type: ProgrammesDumpReportReduxTypes.PROGRAMMES_DUMP_REPORT_ERROR,
            payload: { error: error }
        });
    }
}

export function* watchCreateProgrammesDumpReport() {
    yield takeEvery(
        ProgrammesDumpReportReduxTypes.PROGRAMMES_DUMP_REPORT,
        createProgrammesDumpReport
    );
}

function* programmesDumpReportSaga() {
    yield all([fork(watchCreateProgrammesDumpReport)]);
}

export default programmesDumpReportSaga;